import { State as AppState } from '@app-store/reducers';
import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';
import * as taskTabReducer from './task-tab.reducer';

export interface State extends AppState {
	tasks: TasksState;
}

export interface TasksState {
	taskTabState: taskTabReducer.TaskTabStateMap;
}

export const reducers: ActionReducerMap<TasksState> = {
	taskTabState: taskTabReducer.reducer,
};

export const selectTasksState = createFeatureSelector<TasksState>('tasks');
